var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_7_368)","key":0},[React.createElement("path",{"d":"M3.42387 4.2998H16.7572C17.6739 4.2998 18.4239 5.0498 18.4239 5.96647V15.9665C18.4239 16.8831 17.6739 17.6331 16.7572 17.6331H3.42387C2.5072 17.6331 1.7572 16.8831 1.7572 15.9665V5.96647C1.7572 5.0498 2.5072 4.2998 3.42387 4.2998Z","stroke":"#8AA487","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.4239 5.96631L10.0905 11.7996L1.7572 5.96631","stroke":"#8AA487","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_7_368"},React.createElement("rect",{"width":"20","height":"20","fill":"white","transform":"translate(0.0905762 0.966309)"})))]);
}

Email.defaultProps = {"viewBox":"0 0 21 21","fill":"none"};

module.exports = Email;

Email.default = Email;
